export default __webpack_public_path__ + "static/media/white_print.34246f5e.svg";